/**
 * Used to exclude certain elements when using `getSelectedBlockComponentsByRange`.
 */
export const RANGE_QUERY_EXCLUDE_ATTR = 'data-range-query-exclude';

/**
 * Used to mark certain elements so that they are excluded when synchronizing the native range and text selection (such as database block).
 */
export const RANGE_SYNC_EXCLUDE_ATTR = 'data-range-sync-exclude';

/**
 * Marks a surface that is not a BlockSuite editor but is nested in one and
 * owns the focus, pointer and keyboard inside it, the way a nested
 * `editor-host` does (the drawing board's canvas). Blocks of the host
 * rendered back inside such a surface belong to the host again: ownership
 * goes to the nearest boundary, a block element or this marker.
 */
export const NESTED_INPUT_OWNER_ATTR = 'data-xuwo-input-owner';
